import React, { useContext, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Figure,
  FigureCaption,
  Image,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./header";
import Footer from "./footer";
import { UserContext } from "../../use_context";

const API_BASE_URL = process.env.REACT_APP_SEARCH_API;

function WorkListing() {
  const [selCatId, setSelCatId] = useState(null);
  const {
    workData,
    workCategoryData,
    images,
    setImages,
    setWorkCategoryData,
    setWorkData,
    setSelectedCategoryId,
  } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const Preloader = () => (
    <div className="loader-mask">
      <div className="loader"></div>
    </div>
  );

  const handleCategorySelect = (categoryId) => {
    setSelCatId(categoryId);
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true);

  //       const [workCategoryResponse, workResponse] = await Promise.all([
  //         axios.get(`${API_BASE_URL}/work-category/`),
  //         axios.get(`${API_BASE_URL}/work?per_page=100`),
  //       ]);

  //       const categories = workCategoryResponse.data;
  //       const works = workResponse.data;

  //       setWorkCategoryData(categories);
  //       setWorkData(works);

  //       const featuredCategory = categories.find(
  //         (cat) => cat.name.toLowerCase() === "featured"
  //       );
  //       if (featuredCategory) {
  //         setSelCatId(featuredCategory.id);
  //       }

  //       const imageMap = {};
  //       const imagePromises = works.map(async (work) => {
  //         const mediaId = work.featured_media;
  //         if (mediaId) {
  //           try {
  //             const mediaResponse = await axios.get(
  //               `${API_BASE_URL}/media/${mediaId}`
  //             );
  //             imageMap[work.id] = mediaResponse.data.guid.rendered;
  //           } catch (mediaError) {
  //             console.error(
  //               `Error fetching media for ID ${mediaId}:`,
  //               mediaError
  //             );
  //           }
  //         }
  //       });

  //       await Promise.all(imagePromises);
  //       setImages(imageMap);
  //     } catch (error) {
  //       console.error("Error fetching data", error);
  //       setError(error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [workCategoryResponse, workResponse] = await Promise.all([
          axios.get(`${API_BASE_URL}/work-category/`),
          axios.get(`${API_BASE_URL}/work?per_page=100`),
        ]);

        const categories = workCategoryResponse.data;
        const works = workResponse.data;

        setWorkCategoryData(categories);
        setWorkData(works);

        const featuredCategory = categories.find(
          (cat) => cat.name.toLowerCase() === "featured"
        );
        if (featuredCategory) {
          setSelCatId(featuredCategory.id);
        }

        const imageMap = {};
        const imagePromises = works.map(async (work) => {
          const mediaId = work.featured_media;
          if (mediaId) {
            try {
              const mediaResponse = await axios.get(
                `${API_BASE_URL}/media/${mediaId}`
              );
              imageMap[work.id] = mediaResponse.data.guid.rendered;
            } catch (mediaError) {
              console.error(
                `Error fetching media for ID ${mediaId}:`,
                mediaError
              );
            }
          }
        });

        await Promise.all(imagePromises);
        setImages(imageMap);
      } catch (error) {
        console.error("Error fetching data", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    // ✅ Fetch only if context data is empty
    if (!workData.length || !workCategoryData.length) {
      fetchData();
    } else {
      // Use cached data, set selected category if not already set
      if (!selCatId) {
        const featuredCategory = workCategoryData.find(
          (cat) => cat.name.toLowerCase() === "featured"
        );
        if (featuredCategory) {
          setSelCatId(featuredCategory.id);
        }
      }
      setLoading(false);
    }
  }, []);

  return (
    <main>
      <div>
        <Header onTagClick={handleCategorySelect} />
      </div>
      <section className="responsive-padding">
        <div>
          {loading && <Preloader />}
          {error && <p>Error: {error.message}</p>}
          <Row className="work-listing gx-5" style={{ direction: "rtl" }}>
            {workData
              .filter(
                (workItem) =>
                  selCatId === null ||
                  workItem["work-category"].includes(selCatId)
              )
              .map((workItem) => {
                const imageUrl = images[workItem.id];
                return (
                  <Col
                    className="worklisting-image"
                    key={workItem.id}
                    xs={12}
                    md={6}
                    lg={4}
                    onClick={() => {
                      setSelectedCategoryId(workItem.id);
                    }}
                  >
                    <Link to={`/worksdetails/${workItem.id}`}>
                      <div className="work-listing-item mix featured card media-card workplaces">
                        <Figure>
                          {imageUrl && (
                            <Image
                              src={imageUrl}
                              alt={`Work item ${workItem.id}`}
                              className="img2"
                            />
                          )}
                          <FigureCaption>
                            <span className="title">
                              {workItem.title.rendered}
                            </span>
                            <span
                              className="location"
                              style={{ textDecoration: "none" }}
                            >
                              {workItem.acf?.location}
                            </span>
                          </FigureCaption>
                        </Figure>
                      </div>
                    </Link>
                  </Col>
                );
              })}
          </Row>
        </div>
      </section>
      <Footer />
    </main>
  );
}

export default WorkListing;
